<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert, Container, Text, Token } from '@Shelly/shelly-design-system';
	//Hooks
	import { createEventDispatcher } from 'svelte';
	//Helpers
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	//Components
	import WebhookAdditionalConditions from './WebhookAdditionalConditions.svelte';
	import RepeatWhen from '../Actions/RepeatWhen.svelte';
	//Types
	import type { WebHooksParams } from 'src/types/requests/settings/webhooks';

	export let eventsOptions: any[],
		eventsIndex = -1,
		actionProps: WebHooksParams,
		error: { show: boolean; label: string };

	const dispatch = createEventDispatcher();
</script>

{#if eventsOptions.length == 1 && (eventsOptions[eventsIndex]?.config?.name || eventsOptions[eventsIndex]?.title)}
	{@const title = eventsOptions[eventsIndex]?.config?.name
		? translateTemplateTitle(eventsOptions[eventsIndex].config.name) +
			' ' +
			$format('action_on_change', {
				default: 'is on change',
			})
		: eventsOptions[eventsIndex]?.title}

	<Text element="h2" class="mb-s">
		{$format('web_hook_when', { default: 'When' })}
		<span class="text-primary">{title}</span>
	</Text>
{:else}
	<Text element="h2" class="mb-s">
		{$format('web_hook_when', { default: 'When' })}
	</Text>
	<div class="d-flex flex-wrap" style="gap: var(--spacing-s);">
		{#each eventsOptions as option}
			<Token
				id={`token-event-${option.value}`}
				size="l"
				title={option.title}
				selected={option === eventsOptions[eventsIndex]}
				on:click={() => {
					dispatch('change', option);
				}}
			/>
		{/each}
	</div>
{/if}

{#if eventsOptions[eventsIndex]?.disabled}
	<Alert
		type="warning"
		isHeadingBold
		heading={$format('label_info', { default: 'Information' })}
		class="mt-s"
		message={$format('hook_does_not_match_the_current_component', {
			default: "Hook doesn't match the current component mode and may not work.",
		})}
	/>
{:else if !/^(em|boolean|button|enum|number)$/.test(eventsOptions[eventsIndex]?.type) && /.(measurement|change)/i.test(eventsOptions[eventsIndex]?.event)}
	<Text styleType="body-small" class="mt-m text-bold">
		{$format('webhook_when_title', {
			default: 'When would this web hook execute:',
		})}
	</Text>
	{#if /measurement/g.test(eventsOptions[eventsIndex]?.event)}
		<Text styleType="body-small" class="mb-s">
			{$format('webhook_measurement_info', {
				default:
					'- Measurement based - Event is executed every 60s, ignoring any threshold configuration.',
			})}
		</Text>
	{:else}
		<Text styleType="body-small"
			>{$format('webhook_threshold_info', {
				default: '- Threshold based - Event is executed, based on the configured threshold',
			})}</Text
		>
	{/if}
{/if}
{#if eventsIndex !== -1}
	<WebhookAdditionalConditions bind:eventsOptions bind:eventsIndex {error} />
	{#if actionProps?.repeat_period != null}
		<Container type="borderDashed" class="mt-m" padding="m">
			<RepeatWhen bind:repeat_period={actionProps.repeat_period} /></Container
		>
	{/if}
{/if}
